import React from 'react';

// Playing card suits for decoration
export const CardSuit = ({ suit, className = "" }) => {
  const suits = {
    spades: "♠",
    hearts: "♥",
    diamonds: "♦",
    clubs: "♣"
  };
  
  const colors = {
    spades: "#000",
    hearts: "#F62D2D",
    diamonds: "#F62D2D",
    clubs: "#000"
  };
  
  return (
    <span className={className} style={{ color: colors[suit], fontSize: '1.5em' }}>
      {suits[suit]}
    </span>
  );
};

// Playing card component
export const PlayingCard = ({ value, label, suit, isAnimating = false, className = "" }) => {
  // Check if this is the dollars staked card
  const isDollarsCard = label === "Dollars Staked";
  
  return (
    <div className={`playing-card ${isAnimating ? 'card-flip' : ''}`}>
      <div className="card-corner top-left">
        <CardSuit suit={suit} className="card-suit" />
      </div>
      
      <div className="card-center">
        <div className="stat-value">{value}</div>
        <div className="stat-label">{label}</div>
      </div>
      
      <div className="card-corner bottom-right">
        <CardSuit suit={suit} className="card-suit rotated" />
      </div>
    </div>
  );
};